import React, { useContext } from 'react';
import { priceFormatter } from 'src/utils/utils';
import { isListingOffMarket } from 'lib/checkListingStatus';
import { NO_DATA_PLACEHOLDER } from 'constants/labels';
import {
  UnitPageContext,
  UnitPageContextInterface,
} from 'pages/[urlParam]/[urlBuildParam]/[urlUnitParam]';
import GalleryPopupHeader from './GalleryPopupHeader';

const UnitGalleryPopupHeader: React.FC<{ onClose?: () => void }> = ({
  onClose,
}) => {
  const { building, unit, listing } = useContext(
    UnitPageContext
  ) as UnitPageContextInterface;
  const { bedsTotal, sqft, bathsFull, bathsHalf, price, statusCode } = listing;

  function renderBathrooms() {
    return (
      (bathsHalf && bathsHalf > 0 ? bathsFull + 0.5 : bathsFull) ||
      NO_DATA_PLACEHOLDER
    );
  }

  const stats = [
    !isListingOffMarket(statusCode) ? priceFormatter(price) : null,
    `${bedsTotal} bds`,
    `${renderBathrooms()} ba`,
    `${sqft} sqft`,
  ].filter(Boolean) as string[];

  const name = `${building?.name} #${unit?.unique}`;

  return (
    <div className="relative">
      <GalleryPopupHeader name={name} stats={stats} onClose={onClose} />
    </div>
  );
};

export default UnitGalleryPopupHeader;
